<template>
  <div>
    <toggle :label="i18n.t('public.local.include_virtual_events')"
            field="include_virtual_events" :initial-value="virtualIncluded"
            @change="({ value }) => updateVirtual(value)" />

    <toggle :label="i18n.t('public.local.include_non_virtual_events')"
            field="include_non_virtual_events" :initial-value="inPersonIncluded"
            @change="({ value }) => updateInPerson(value)" />
  </div>
</template>

<script>
import Toggle from '../components/inputs/toggle'

export default {
  components: { Toggle },

  props: {
    initialValue: {
      type: String,
      required: false
    }
  },

  emits: ['change'],

  data() {
    return {
      inPersonIncluded: this.initialValue !== 'virtual_only',
      virtualIncluded: this.initialValue !== 'in_person_only'
    }
  },

  computed: {
    value() {
      if (this.inPersonIncluded) {
        if (this.virtualIncluded) {
          return 'all'
        } else {
          return 'in_person_only'
        }
      } else {
        if (this.virtualIncluded) {
          return 'virtual_only'
        } else {
          return 'none'
        }
      }
    }
  },

  methods: {
    emitValue() {
      this.$emit('change', this.value)
    },

    updateInPerson(newValue) {
      this.inPersonIncluded = newValue
      this.emitValue()
    },

    updateVirtual(newValue) {
      this.virtualIncluded = newValue
      this.emitValue()
    }
  }
}
</script>
